import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {LoginComponent} from './admin/login/login.component';
import {AppRoutingModule} from './/app-routing.module';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HomeComponent} from './admin/home/home.component';
import {ProgramacionComponent} from './admin/programacion/programacion.component';
import {ItemComponent} from './admin/item/item.component';
import {HeaderComponent} from './admin/header/header.component';


import {NgbModule} from '@ng-bootstrap/ng-bootstrap'; // Bootstrap for Angular
import {DndListModule} from 'ngx-drag-and-drop-lists'; // Drag and drog

import {UploadViewComponent} from './admin/upload-view/upload-view.component'; // Upload File
import {Auth} from './providers/auth';
import {AsyncLocalStorageModule} from 'angular-async-local-storage';
import {HttpClientModule} from '@angular/common/http';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {Api} from './providers/api';
import {EntitlementService} from './providers/entitlement.service';
import {NgxSpinnerModule} from 'ngx-spinner';
import {FrameViewComponent} from './admin/frame-view/frame-view.component';
import {UploadFormComponent} from './admin/upload-form/upload-form.component';
import {VgCoreModule} from 'videogular2/core';
import {VgControlsModule} from 'videogular2/controls';
import {VgOverlayPlayModule} from 'videogular2/overlay-play';
import {VgBufferingModule} from 'videogular2/buffering';
import {NoticiasComponent} from './admin/noticias/noticias.component';
import {NgUploaderModule} from 'ngx-uploader';
import { SettingComponent } from './admin/setting/setting.component';
import { VincularTvComponent } from './admin/setting/vincular-tv/vincular-tv.component';
import {ModalNewNoticiaComponent} from './admin/modal-new-noticia/modal-new-noticia.component';
import {ModalGrupoComponent} from './admin/modal-grupo/modal-grupo.component';
import {ModalEquipoComponent} from './admin/modal-equipo/modal-equipo.component';
import { RegistroComponent } from './admin/registro/registro.component';
import { ActivacionComponent } from './admin/activacion/activacion.component';
import { RecuperarComponent } from './admin/recuperar/recuperar.component';
import { RecoveryPassComponent } from './admin/recovery-pass/recovery-pass.component';
import { AdminCodeRecoveryComponent } from './admin/admin-code-recovery/admin-code-recovery.component';
import { RegisterWizardComponent } from './admin/register-wizard/register-wizard.component';
import { PagoComponent } from './pago/pago.component';
import { InviteModalComponent } from './admin/invite-modal/invite-modal.component';
import { RecoveryLinkModalComponent } from './admin/recovery-link-modal/recovery-link-modal.component';
import { EditUserModalComponent } from './admin/edit-user-modal/edit-user-modal.component';
import { ConfirmModalComponent } from './admin/confirm-modal/confirm-modal.component';
import { MaintainerConsoleComponent } from './system/maintainer/maintainer-console.component';
import { SubscriptionExpiredModalComponent } from './shared/subscription-expired-modal/subscription-expired-modal.component';
import { AuthGuard } from './providers/auth.guard';


const optionsProgress = {};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ProgramacionComponent,
    ItemComponent,
    HeaderComponent,
    UploadViewComponent,
    UploadFormComponent,
    FrameViewComponent,
    NoticiasComponent,
    SettingComponent,
    VincularTvComponent,
    ModalNewNoticiaComponent,
    ModalGrupoComponent,
    ModalEquipoComponent,
    RegistroComponent,
    RegisterWizardComponent,
    PagoComponent,
    ActivacionComponent,
    RecuperarComponent,
    RecoveryPassComponent,
    AdminCodeRecoveryComponent,
    InviteModalComponent,
    RecoveryLinkModalComponent,
    EditUserModalComponent,
    ConfirmModalComponent,
    MaintainerConsoleComponent,
    SubscriptionExpiredModalComponent
  ],
  imports: [ReactiveFormsModule,
    HttpClientModule,  // http module
    AsyncLocalStorageModule, // localstorage
    BrowserModule,
    NgbModule.forRoot(), // Bootstrap
    DndListModule,       // Drag and Drop Libreria
    NgxSpinnerModule,
    AppRoutingModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    NgUploaderModule,
    NgCircleProgressModule.forRoot(optionsProgress), // progress
    FormsModule],
  providers: [Auth, Api, AuthGuard, EntitlementService],
  bootstrap: [AppComponent],
  entryComponents: [SubscriptionExpiredModalComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts